export const TEXT_WIDTH = 122;
export const TEXT_HEIGHT = 18;
